<template>
  <div>
    <transition v-on:before-enter="beforeEnter" v-on:enter="enter" v-bind:css="false">
      <div class="s-container" ref="sContainer">
        <div class="home-linea-grande"></div>
        <Logo></Logo>
      </div>
    </transition>
    <div class="home-options-container">
      <transition name="fade" :duration="500">
        <div
          class="home-option-container"
          ref="homeOptionContainerProyectos"
          @mouseenter="enterProyectos"
          @mouseleave="leaveProyectos"
          v-if="mostrarProyectosContainer"
          @click="abrirProyectos"
        >
          <p class="home-option-title" ref="homeOptionProyectosTitle">Proyectos</p>
          <transition name="fade">
            <p
              class="home-option-subtitle"
              v-if="mostrarProyectos"
            >Asesoramiento, diseño y desarrollo
              <br>integro de diversas plataformas digitales
            </p>
          </transition>
          <transition name="fade">
            <p class="home-option-more" v-if="mostrarProyectos">VER +</p>
          </transition>
        </div>
      </transition>
      <transition name="fade" :duration="500">
        <div
          class="home-option-container"
          ref="homeOptionContainerContacto"
          v-if="mostrarContactoContainer"
          @mouseenter="enterContacto"
          @mouseleave="leaveContacto"
          @click="abrirContacto"
        >
          <p class="home-option-title" ref="homeOptionContactoTitle">Contacto</p>
          <transition name="fade">
            <p class="home-option-subtitle" v-if="mostrarContacto">
              Realizar una consulta o solicita presupuesto aquí
              <img
                class="home-option-subtitle-arrow"
                :src="require('@/assets/img/arrow_white_right.png')"
              >
            </p>
          </transition>
        </div>
      </transition>
    </div>
    <Proyectos></Proyectos>
    <Contacto></Contacto>
  </div>
</template>

<script>
import velocity from "velocity-animate";
import Logo from "@/components/Logo.vue";
import Vue from "vue";
import Proyectos from "@/components/Proyectos.vue";
import Contacto from "@/components/Contacto.vue";

window.Event = new Vue();

export default {
  name: "home",
  data() {
    return {
      logoCompleted: false,
      mostrarProyectosContainer: false,
      mostrarContactoContainer: false,
      mostrarProyectos: false,
      mostrarContacto: false,
      puedoAnimarProyecto: true,
      puedoAnimarContacto: true
    };
  },
  components: {
    Logo,
    Proyectos,
    Contacto
  },
  created() {
    Event.$on("linea-chica-completed", () => this.enter(this.$refs.sContainer));
    Event.$on(
      "logo-container-completed",
      () => (
        (this.mostrarProyectosContainer = true),
        setTimeout(
          function() {
            this.mostrarContactoContainer = true;
          }.bind(this),
          500
        )
      )
    );
  },
  methods: {
    beforeEnter: function(el) {
      el.style.left = 0;
    },
    enter: function(el) {
      if(window.screen.width < 500){
        velocity(el, { left: "-18.7vw" }, { duration: 1000 });
      }else{
        velocity(el, { left: "-38.7vw" }, { duration: 1000 });
      }
      velocity(el, {
        complete: function() {
          Event.$emit("linea-grande-completed");
        }
      });
    },
    enterProyectos: function() {
      if (this.puedoAnimarProyecto == true) {
        this.puedoAnimarProyecto = false;
        this.mostrarProyectos = true;
      }
    },
    leaveProyectos: function() {
      this.puedoAnimarProyecto = false;
      setTimeout(
        function() {
          this.puedoAnimarProyecto = true;
        }.bind(this),
        100
      );
      this.mostrarProyectos = false;
    },
    enterContacto: function() {
      if (this.puedoAnimarContacto == true) {
        this.puedoAnimarContacto = false;
        this.mostrarContacto = true;
      }
    },
    leaveContacto: function() {
      setTimeout(
        function() {
          this.puedoAnimarContacto = true;
        }.bind(this),
        450
      );
      this.mostrarContacto = false;
    },
    abrirProyectos: function() {
      Event.$emit("abrir-proyectos");
    },
    abrirContacto: function() {
      Event.$emit("abrir-contacto");
    }
  }
};
</script>

<style>
@import "../assets/css/home.css";

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.home-option-container {
  transition: all 0.5s ease;
}
.home-option-container:hover {
  height: 14vw;
}
.home-option-container:hover .home-option-title {
  font-size: 4.3vw;
}
p {
  transition: all 0.5s ease;
}
</style>
